
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class UnsaveChangesGuard  {
  canDeactivate(component: ComponentCanDeactivate | null): boolean | Observable<boolean> {
    return component?.canDeactivate?.() ?? true;
  }
}